<template>
  <div class="Fuell-ToolbarSearch">
    <span class="Fuell-ToolbarSearch--icon">
      <img
        :src="require('@/assets/img/icons/icon-search.svg')"
        alt="search"
      >
    </span>
    <input
      class="Fuell-ToolbarSearch--input"
      type="text"
      v-model="searchQuery"
      :placeholder="$t(placeholder)"
      @blur="emitSearch"
      @keydown="handleKeyDown"
      @input="debounceSearch"
    >
  </div>
</template>

<script>
export default {
  name: 'EntitySearchInput',
  props: {
    placeholder: {
      type: String,
      default: 'ACTION_SEARCH'
    }
  },
  data () {
    return {
      searchQuery: '',
      debounce: undefined
    }
  },
  methods: {
    handleKeyDown (event) {
      if (event && event.keyCode === 13) {
        this.emitSearch()
      }
    },
    emitSearch () {
      this.$emit('search', this.searchQuery)
    },
    handleInput () {
      if (this.searchQuery.length > 2 || this.searchQuery.length === 0) {
        this.$emit('search', this.searchQuery)
      }
    },
    debounceSearch () {
      if (this.debounce) clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.handleInput()
      }, 250)
    }
  }
}

</script>

<style>
</style>
